export default __webpack_public_path__ + "static/media/logo.052a07ec.png";